import '../lib/typedef';
// import { buildQuery } from '../lib/helper';
import client from '@/lib/http-client';

const endpoint = '/orderonline';

export default {
	// Create customer (if exist) and get token
	createCustomer(params, cb, errorCb) {
		const url = `${endpoint}/customer/create`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getAddedDropshipProducts(params, cb, errorCb) {
		const url = `${endpoint}/product/added`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},

	addDropshipProduct(params, cb, errorCb) {
		const url = `${endpoint}/product/add`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	duplicateFunnel(params, cb, errorCb) {
		const url = `${endpoint}/funnel/duplicate`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
